import { Routes, Route, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar.tsx';
import Footer from './components/Footer.tsx';
import HomePage from './pages/HomePage.tsx';
import CommandsPage from './pages/CommandsPage.tsx';
import ContactPage from './pages/ContactPage.tsx';
import OgPreviewHome from './pages/OgPreviewHome.tsx';
import OgPreviewCommands from './pages/OgPreviewCommands.tsx';
import OgPreviewContact from './pages/OgPreviewContact.tsx';
import ServerSelector from './pages/dashboard/ServerSelector.tsx';
import ServerDashboard from './pages/dashboard/ServerDashboard.tsx';
import { AuthProvider } from './contexts/AuthContext.tsx';
import { useBotFavicon } from './hooks/useBotFavicon.ts';

function AppContent() {
  const location = useLocation();
  const isDashboardServer = location.pathname.match(/^\/dashboard\/\d+/);

  // Dynamically set favicon from Discord API
  useBotFavicon();

  return (
    <div className="min-h-screen flex flex-col bg-dark">
      <Navbar />
      <main className="flex-1">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/commands" element={<CommandsPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/dashboard" element={<ServerSelector />} />
          <Route path="/dashboard/:guildId/*" element={<ServerDashboard />} />
          {/* OG preview-only routes for generating social images */}
          <Route path="/og-preview/home" element={<OgPreviewHome />} />
          <Route path="/og-preview/commands" element={<OgPreviewCommands />} />
          <Route path="/og-preview/contact" element={<OgPreviewContact />} />
        </Routes>
      </main>
      {!isDashboardServer && <Footer />}
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
}

export default App;
